import defaultSettings from '@/settings'

const title = defaultSettings.title || '万咖聚投'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
